var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-tabs"},[_c('tabs',_vm._g(_vm._b({attrs:{"items":_vm.visibleTabs},on:{"change":_vm.setTab}},'tabs',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }